module.exports = __webpack_public_path__ + "static/img/jprm-1.4267c79c.png";